import { AxiosInstance } from "axios";
import { BaseHTTP } from "./base.http";

export interface ITranscribeResponse {
  transcription: string;
}

export interface ITranscribeOptions {
  languageCode?: string;
  sampleRateHertz?: number;
  enableAutomaticPunctuation?: boolean;
  enableWordTimeOffsets?: boolean;
}

export class SpeechToTextApi {
  private http !: AxiosInstance

  constructor() {
    this.http = BaseHTTP.getInstance().http
  }

  async transcribe(audioFile: File, options?: ITranscribeOptions): Promise<ITranscribeResponse> {
    const formData = new FormData()
    formData.append('audio', audioFile)

    if (options?.languageCode) {
      formData.append('languageCode', options.languageCode)
    }

    if (options?.sampleRateHertz) {
      formData.append('sampleRateHertz', options.sampleRateHertz.toString())
    }

    if (options?.enableAutomaticPunctuation !== undefined) {
      formData.append('enableAutomaticPunctuation', options.enableAutomaticPunctuation.toString())
    }

    if (options?.enableWordTimeOffsets !== undefined) {
      formData.append('enableWordTimeOffsets', options.enableWordTimeOffsets.toString())
    }

    try {
      const response = await this.http.post<ITranscribeResponse>(
        'v1/speech-to-text/transcribe',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )

      if (!response.data || typeof response.data.transcription !== 'string') {
        throw new Error('Invalid response format from transcription API')
      }

      return response.data
    } catch (error: any) {
      throw new Error(`Transcription failed: ${error?.message || 'Unknown error'}`)
    }
  }
}

export default new SpeechToTextApi()

